import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { UserDto } from '@api/models/user/UserDto';
import { UserState } from '@api/models/enums/UserState';
import { userService } from '@api/services/services';

export interface QcsAdminUserListFilter extends ListFilter {
  state?: UserState[];
}

export type QcsAdminUserListState = ListType<UserDto, QcsAdminUserListFilter>;

const initialState: QcsAdminUserListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'name',
    sortDesc: false,
    state: [UserState.Active],
  },
};

export const qcsAdminUserListSlice = listSlice({
  name: 'qcsAdminUserList',
  initialState,
});

export const selectQcsAdminUserList = (state: RootState) => state.qcsAdminUserList;
export const qcsAdminUserListActions = qcsAdminUserListSlice.actions;

export const getQcsAdminUserList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectQcsAdminUserList(storeState);

  const handleGetData = (size: number) => {
    return userService.queryQcsCoreUsers(
      {
        q: data.query.q,
        state: data.query.state,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken },
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: qcsAdminUserListActions,
    getData: handleGetData,
  });
};
